var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label",attrs:{"for":_vm.labelKey}},[_c('lang',{attrs:{"labelKey":_vm.labelKey}}),(_vm.tipp)?[_c('tooltip',{attrs:{"slot":"icon","content":_vm.tipp},slot:"icon"},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-question-circle-o"})])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }